!function() {
  "use strict";
  
  const BUTTON_SELECTOR = "[data-discount-code-button]";
  const COPIED_CLASS = "is-copied";
  const ANIMATION_DURATION = 3000;

  class DiscountBar extends HTMLElement {
    constructor() {
      super();
      this.discountCode = "";
      this.init();
    }

    init() {
      const button = this.querySelector(BUTTON_SELECTOR);
      if (button) {
        button.addEventListener("click", this.copyToClipboard.bind(this));
        this.discountCode = button.dataset.discountCode || "";
      }
    }

    async copyToClipboard(event) {
      const button = event.currentTarget;
      if (!button) return;

      const code = this.discountCode || button.dataset.discountCode;
      if (!code) return;

      try {
        // Modern clipboard API
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          this.showCopiedAnimation(button);
        } else {
          // Fallback for older browsers
          const textArea = document.createElement("textarea");
          textArea.value = code;
          textArea.style.position = "fixed";
          textArea.style.left = "-999999px";
          document.body.appendChild(textArea);
          textArea.select();
          textArea.setSelectionRange(0, 99999); // For mobile devices

          try {
            document.execCommand("copy");
            this.showCopiedAnimation(button);
          } catch (err) {
            console.error("Fallback: Oops, unable to copy", err);
          }

          document.body.removeChild(textArea);
        }
      } catch (err) {
        console.error("Failed to copy discount code:", err);
      }
    }

    showCopiedAnimation(button) {
      // Store the original width before copying
      if (!button.dataset.originalWidth) {
        button.dataset.originalWidth = button.offsetWidth + 'px';
        button.style.setProperty('--button-width', button.dataset.originalWidth);
      }
      
      // Force a reflow to ensure the class addition triggers the animation
      void button.offsetWidth;
      
      button.classList.add(COPIED_CLASS);
      
      // Remove the class after animation duration
      setTimeout(() => {
        button.classList.remove(COPIED_CLASS);
      }, ANIMATION_DURATION);
    }
  }

  // Register the custom element
  if (!customElements.get("discount-bar")) {
    customElements.define("discount-bar", DiscountBar);
  }
}();
